import { ButtonLink, Question } from '@workspace/core-ts/components';
import { documentsStepContent } from '@workspace/core-ts/content';
import { useEffect } from 'react';
import { SmartFormGlobal, useGlobalForm, useSmartFormGlobal } from '../../contexts';
import { useContent, useSource } from '../../hooks';
import { Fingers } from '../../icons-amo';
import type { StepContentConfig } from '../../utils';

interface DocumentsStepProps {
    content?: StepContentConfig;
    showIcon?: boolean;
    iconComponent?: React.ComponentType<{ className?: string }>;
}

export function DocumentsStep({ content = documentsStepContent, showIcon = true, iconComponent: IconComponent = Fingers }: DocumentsStepProps) {
    const methods = useSmartFormGlobal<any>();
    const {isConseiller} = useSource()
    const { setDisableNavigation, others } = useGlobalForm();
    const documentsUrl = others.documents_url;
    const r = useContent();

    useEffect(() => {
        setDisableNavigation(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <SmartFormGlobal
            {...methods}
            className="mx-auto max-w-3xl w-full md:pt-12"
        >
            <div className="flex flex-col md:flex-row w-full gap-8 items-center text-center md:text-left">
                {showIcon && (
                    <div className="flex justify-center items-center h-36 w-36 md:h-56 md:w-56 aspect-square bg-card rounded-full">
                        <IconComponent className="h-16 sm:h-24 w-auto" />
                    </div>
                )}
                <div className="space-y-4 flex-1">
                    <Question.Title className="font-medium flex-1 text-lg">{r(content.mainTitle)}</Question.Title>
                    <div className="text-sm">
                        {(r(content.description) as Array<any>).map((line, index) => (
                            <p key={index}>{line}</p>
                        ))}
                    </div>

                    {!isConseiller && (
                        <ButtonLink to={documentsUrl}>{r(content.buttonText)}</ButtonLink>
                    )}
                </div>
            </div>
        </SmartFormGlobal>
    );
}
